
import { useSelector  } from 'react-redux';

export default function useProjectDefinition() {
    const projectDefinition = useSelector(state => state.project.project.project);
    return projectDefinition;
}
